var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { NativeNumberInput } from '../../common/nativeNumberInput';
import { getShrinkageDisplayValue, getShrinkagePercentValue, getShrinkageUnitInputMeta } from './useShrinkageUnit';
export var ShrinkageUnitInput = function (_a) {
  var value = _a.value,
    onChange = _a.onChange,
    unit = _a.unit,
    paidHoursPerDay = _a.paidHoursPerDay,
    businessDays = _a.businessDays,
    props = __rest(_a, ["value", "onChange", "unit", "paidHoursPerDay", "businessDays"]);
  var displayValue = useMemo(function () {
    return getShrinkageDisplayValue(value, unit, paidHoursPerDay, businessDays);
  }, [value, unit, paidHoursPerDay, businessDays]);
  var handleChange = function (newDisplayVal) {
    onChange === null || onChange === void 0 ? void 0 : onChange(getShrinkagePercentValue(newDisplayVal, unit, paidHoursPerDay, businessDays));
  };
  var _b = getShrinkageUnitInputMeta(unit),
    min = _b.min,
    max = _b.max,
    suffix = _b.suffix,
    decimal = _b.decimal;
  return _jsx(NativeNumberInput, __assign({}, props, {
    value: displayValue,
    onChange: handleChange,
    suffix: suffix,
    min: min,
    max: max,
    decimal: decimal
  }));
};